export default `
  mutation removeGitHubToken($username: String!) {
    removeGitHubToken(username: $username) {
      success
      errorText
      resData {
        githubAccounts {
          login
          avatar
        }
      }
    }
  }
`
